import Cookies from 'js-cookie';

// Constantes para armazenamento
const ACCESS_TOKEN = 'tz-suporte.token';
const ACCESS_REFRESH_TOKEN = 'tz-suporte.refresh_token';
const ACCESS_USER = 'tz-suporte.user';

const ONE_HOUR = 1 / 24; // Tempo de expiração do token em dias
const ONE_DAY = 1; // Um dia inteiro

// Função para salvar o token
export function saveToken(accessToken) {
  Cookies.set(ACCESS_TOKEN, accessToken, {
    expires: ONE_HOUR,
    sameSite: 'lax',
    path: '/',
  });
}

// Função para obter o token
export function getToken() {
  return Cookies.get(ACCESS_TOKEN);
}

// Função para salvar o refresh token
export function saveRefreshToken(refreshToken) {
  Cookies.set(ACCESS_REFRESH_TOKEN, refreshToken, {
    expires: ONE_DAY,
    sameSite: 'lax',
    path: '/',
  });
}

// Função para obter o refresh token
export function getRefreshToken() {
  return Cookies.get(ACCESS_REFRESH_TOKEN);
}

// Função para salvar dados do usuário
export function saveDataUser(user) {
  const dataUser = JSON.stringify(user);
  Cookies.set(ACCESS_USER, dataUser, {
    expires: ONE_DAY * 2,
    sameSite: 'lax',
    path: '/',
  });
}

// Função para obter dados do usuário
export function getDataUser() {
  const userString = Cookies.get(ACCESS_USER);
  return userString ? JSON.parse(userString) : null;
}

// Função para remover tokens e dados do usuário
export function removeAccess() {
  Cookies.remove(ACCESS_TOKEN);
  Cookies.remove(ACCESS_REFRESH_TOKEN);
  Cookies.remove(ACCESS_USER);
}

export function clearAllCookies() {
  Object.keys(Cookies.get()).forEach((cookieName) => {
    Cookies.remove(cookieName, { path: '/' });
    Cookies.remove(cookieName); // fallback pra paths diferentes
  });
}
